// Formato fijo que solo usan las notas crédito: prefijo y seis dígitos. Órdenes,
// despachos y facturas traen del backend el display_number que guardaron al
// crearse.
const formatDocumentNumber = (prefix) => (number) =>
  number === null || number === undefined || number === ''
    ? '-'
    : `${prefix}-${String(number).padStart(6, '0')}`;

export const formatCreditNoteNumber = formatDocumentNumber('BAJ');
